import React from 'react';
import GLP1Navbar from './GLP1Navbar';
import GLP1Footer from './GLP1Footer';

const GLP1Layout = ({ children, showFooter = true }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <GLP1Navbar />
      <main className="flex-grow">
        {children}
      </main>
      {showFooter && <GLP1Footer />}
    </div>
  );
};

export default GLP1Layout;
